import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from "react";
import { groupChaptersByVolume, type ChapterSortDirection, type VolumeChapterMetadata } from "@/lib/reader/volume-chapter-groups";
export function useVolumeChapterGroups(chapters, initialVolumeId) {
  const $ = _c(20);
  const [direction, setDirection] = useState("asc");
  let t0;
  if ($[0] !== initialVolumeId) {
    t0 = () => new Set(initialVolumeId ? [initialVolumeId] : []);
    $[0] = initialVolumeId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [expandedVolumeIds, setExpandedVolumeIds] = useState(t0);
  let t1;
  if ($[2] !== chapters || $[3] !== direction) {
    t1 = groupChaptersByVolume(chapters, direction);
    $[2] = chapters;
    $[3] = direction;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const groups = t1;
  const hasMultipleVolumes = groups.length > 1;
  let t2;
  if ($[5] !== expandedVolumeIds || $[6] !== groups) {
    t2 = groups.length > 0 && groups.every(group => expandedVolumeIds.has(group.id));
    $[5] = expandedVolumeIds;
    $[6] = groups;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const areAllExpanded = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = volumeId => {
      setExpandedVolumeIds(current => {
        const next = new Set(current);
        if (next.has(volumeId)) {
          next.delete(volumeId);
        } else {
          next.add(volumeId);
        }
        return next;
      });
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const toggleVolume = t3;
  let t4;
  if ($[9] !== areAllExpanded || $[10] !== groups) {
    t4 = () => {
      setExpandedVolumeIds(areAllExpanded ? new Set() : new Set(groups.map(_temp)));
    };
    $[9] = areAllExpanded;
    $[10] = groups;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const toggleAllVolumes = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setDirection(_temp2);
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const toggleDirection = t5;
  let t6;
  if ($[13] !== areAllExpanded || $[14] !== direction || $[15] !== expandedVolumeIds || $[16] !== groups || $[17] !== hasMultipleVolumes || $[18] !== toggleAllVolumes) {
    t6 = {
      areAllExpanded,
      direction,
      expandedVolumeIds,
      groups,
      hasMultipleVolumes,
      toggleAllVolumes,
      toggleDirection,
      toggleVolume
    };
    $[13] = areAllExpanded;
    $[14] = direction;
    $[15] = expandedVolumeIds;
    $[16] = groups;
    $[17] = hasMultipleVolumes;
    $[18] = toggleAllVolumes;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function _temp2(current_0) {
  return current_0 === "asc" ? "desc" : "asc";
}
function _temp(group_0) {
  return group_0.id;
}